








import { Prop, Component, Vue } from 'vue-property-decorator';
import { VimeoService, VimeoServiceEvents } from '../services/VimeoService';

declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window { Vimeo: any; }
}

@Component
export default class VimeoPlayerComponent extends Vue {
    @Prop() id!: string;

    public image: string = '';
    public player!: any;

    mounted() {
        if (VimeoService.apiReady) {
            this.initVideo();
        }

        VimeoServiceEvents.$on('apiReady', () => {
            this.initVideo();
        });

        VimeoService.load();
    }


    initVideo() {
        this.player = new window.Vimeo.Player(this.$refs.playerPlaceholder, {
            id: this.id,
            width: '100vw',
            height: '100%',
            transparent: false,
            keyboard: 0
        });

        this.player.on('ended', () => {
            window.dispatchEvent(new Event('videoIsStopped'));
        });

        this.player.on('play', () => {
            window.dispatchEvent(new Event('videoIsPlaying'));
        });

        this.player.on('pause', () => {
            window.dispatchEvent(new Event('videoIsStopped'));
        });
    }
}
